import { api } from './fetch'

class OfflineError extends Error {
  constructor() {
    super('Offline - will sync when online')
    this.name = 'OfflineError'
  }
}

export const s3Service = {
  async uploadSignature(
    base64Data: string,
    tagId: string,
    signatureType: 'supervisor' | 'driver',
  ): Promise<void> {
    try {
      const payload = {
        [signatureType === 'supervisor'
          ? 'supervisor_signature_data'
          : 'driver_signature_data']: base64Data,
      }
      await api.patch(`/tag/${tagId}/`, payload)
    } catch (error) {
      if (!navigator.onLine) {
        console.log('Network error, queueing signature upload')
        throw new OfflineError()
      }
      throw error
    }
  },
}

export async function fetchSignatureAsDataUrl(
  signatureUrl: string | null,
): Promise<string | undefined> {
  if (!signatureUrl) return undefined
  // If already a data URL, return as is
  if (signatureUrl.startsWith('data:')) return signatureUrl

  // Build the proxy URL (with trailing slash)
  let filename: string
  try {
    const url = new URL(signatureUrl)
    const parts = url.pathname.split('/')
    filename = parts[parts.length - 1]
  } catch {
    return undefined
  }
  const proxyUrl = `${
    process.env.NODE_ENV === 'development'
      ? 'http://127.0.0.1:8000'
      : 'https://api.daydaco.net'
  }/api/proxy-signature/${filename}/`

  // Get token from localStorage
  const token = localStorage.getItem('daydaco.authkey')
  if (!token) return undefined

  // Fetch as blob with Authorization header
  const response = await fetch(proxyUrl, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok) return undefined
  const blob = await response.blob()

  // Convert blob to data URL
  return await new Promise((resolve) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.readAsDataURL(blob)
  })
}
